import { render, staticRenderFns } from "./MetricaCount.vue?vue&type=template&id=09b66d72&scoped=true"
import script from "./MetricaCount.vue?vue&type=script&lang=js"
export * from "./MetricaCount.vue?vue&type=script&lang=js"
import style0 from "./MetricaCount.vue?vue&type=style&index=0&id=09b66d72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b66d72",
  null
  
)

export default component.exports